// https://developers.google.com/web/updates/2015/09/history-api-scroll-restoration
if ("scrollRestoration" in history) {
  // Back off, browser, I got this...
  window.history.scrollRestoration = "manual";
}
